import { EditableText } from 'src/v2/commonComponents/EditableText';
import { useEditorTitleRename } from 'src/hooks';
import styles from './EditorEditableTitle.module.scss';

interface EditorEditableTitleProps {
  title: string;
  onEditChange: (isEditing: boolean) => void;
}

export const EditorEditableTitle = ({
  title,
  onEditChange,
}: EditorEditableTitleProps) => {
  const { onTitleRename } = useEditorTitleRename();

  const handleBlur = async (newTitle: string) => {
    await onTitleRename({
      newTitle,
    });
  };

  return (
    <EditableText
      tooltipContent="Rename"
      onBlur={handleBlur}
      onEditChange={onEditChange}
      initialText={title}
      textClassName={styles.title}
      className={styles.textWrapper}
    />
  );
};
